import { render, staticRenderFns } from "./ObjectiveItemComp.vue?vue&type=template&id=cad94638&scoped=true&"
import script from "./ObjectiveItemComp.vue?vue&type=script&lang=ts&"
export * from "./ObjectiveItemComp.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectiveItemComp.vue?vue&type=style&index=0&id=cad94638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad94638",
  null
  
)

export default component.exports